/* Soulrang — Process index interaction.
   Desktop: hovering a row swaps the large image in the stage (exclusive —
   one active row at a time). Mobile: no tap needed — each row opens on its
   own as it scrolls into view (a one-way reveal, like the rest of the
   site's scroll reveals), with tap/keyboard kept as a manual fallback. No
   scroll-jacking or pinning either way — this only reads position/visibility
   and toggles classes; the page scrolls completely normally. */
(function () {
  function setup(section) {
    var rows = Array.prototype.slice.call(section.querySelectorAll('.process-index__row'));
    var frames = Array.prototype.slice.call(section.querySelectorAll('.process-index__frame'));

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function activateDesktop(index) {
      rows.forEach(function (row) {
        var active = row.getAttribute('data-index') === index;
        row.classList.toggle('is-active', active);
        row.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      frames.forEach(function (frame) {
        frame.classList.toggle('is-active', frame.getAttribute('data-index') === index);
      });
    }

    function openMobile(row) {
      if (row.classList.contains('is-active')) return;
      row.classList.add('is-active');
      row.setAttribute('aria-expanded', 'true');
    }

    rows.forEach(function (row) {
      var index = row.getAttribute('data-index');

      row.addEventListener('mouseenter', function () {
        if (isDesktop()) activateDesktop(index);
      });

      row.addEventListener('click', function () {
        if (isDesktop()) {
          activateDesktop(index);
        } else {
          openMobile(row);
        }
      });

      row.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (isDesktop()) {
            activateDesktop(index);
          } else {
            openMobile(row);
          }
        }
      });
    });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    if (reduce || inEditor || !('IntersectionObserver' in window)) {
      rows.forEach(openMobile);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !isDesktop()) {
            openMobile(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -15% 0px', threshold: 0.15 }
    );

    rows.forEach(function (row) {
      observer.observe(row);
    });

    /* Failsafe: if the observer never fires (e.g. the page loaded in a
       backgrounded tab, which throttles IntersectionObserver), make sure
       nothing stays stuck closed once the tab is visible / after a delay. */
    function flushVisible() {
      rows.forEach(function (row) {
        if (row.classList.contains('is-active')) return;
        var rect = row.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          openMobile(row);
          observer.unobserve(row);
        }
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) flushVisible();
    });
    window.setTimeout(flushVisible, 2500);
  }

  function init() {
    document.querySelectorAll('.process-index').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
